import _ from 'lodash';
import moment from 'moment';

export default function formatDate(date, useLocalTime, format) {
	return date !== null && date !== undefined && date !== ''
		? useLocalTime
			? convertToLocalFromUTC(date, format)
			: moment(date)
					.tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
					.format(format)
		: '-';
}

function convertToLocalFromUTC(date, format = null) {
	if (format === null) {
		return moment
			.utc(date)
			.toDate()
			.toLocaleString();
	}
	return moment(
		moment
			.utc(date)
			.toDate()
			.toLocaleString()
	).format(format);
}



// WEBPACK FOOTER //
// ./src/core/utils/formatDate.js